import React from 'react'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'
import { NextRaces } from './NextRaces'

export const NextEventsPage = () => {
  useAppSeo({
    title: 'Next Events | TABtouch',
    description: 'Explore next events content and betting information with TABtouch.',
  })

  return (
    <MainContainer>
      <PageHeader title='Next Races' />

      <NextRaces />
    </MainContainer>
  )
}
